import InvoiceEditor from '../components/invoice/InvoiceEditor';

export default function InvoiceEditorPage({ activeInvoice, tab, dailyLimit, todaySalesExcludingSelf, saleDocumentTitle, onSave, onCancel }) {
  return (
    <InvoiceEditor
      initial={activeInvoice}
      type={tab}
      dailyLimit={dailyLimit}
      todaySalesExcludingSelf={todaySalesExcludingSelf}
      saleDocumentTitle={saleDocumentTitle}
      onSave={onSave}
      onCancel={onCancel}
    />
  );
}
